import HonjoCard from './HonjoCard.vue'

export { HonjoCard }
